import { atom as t } from "jotai/vanilla";
import * as e from "optics-ts";
var n = function n(t, e, _n) {
    return (e.has(_n) ? e : e.set(_n, t())).get(_n);
  },
  o = new WeakMap();
function r(r, a) {
  return function (i, c, p) {
    var f = n(function () {
      return new WeakMap();
    }, o, c);
    return n(function () {
      var n = a(e.optic());
      return t(function (t) {
        var e = t(r);
        return e instanceof Promise ? e.then(function (t) {
          return s(n, t);
        }) : s(n, e);
      }, function (t, o, s) {
        var a = "function" == typeof s ? e.modify(n)(s) : e.set(n)(s),
          i = t(r);
        return o(r, i instanceof Promise ? i.then(a) : a(i));
      });
    }, f, p);
  }(0, r, a);
}
var s = function s(t, n) {
  return "Traversal" === t._tag ? e.collect(t)(n) : "Prism" === t._tag ? e.preview(t)(n) : e.get(t)(n);
};
export { r as focusAtom };